import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { StyledEngineProvider } from "@mui/material/styles";
import './config/firebase'; // 確保 Firebase 初始化

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <App />
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
